export default {
  cross_bracelet: {
    id: 'cross_bracelet',
    category: 'bracelet',
    seller: 'Jerry Chiu',
    img: 'bracelet/cross-bracelet_720x480.jpg',
    title: 'Cross Silver Bracelet',
    price: 14222,
    popular: false
  },
  couple_bracelet: {
    id: 'couple_bracelet',
    category: 'bracelet',
    seller: 'Stephine',
    img: 'bracelet/couple-bracelet_720x480.jpg',
    title: 'Couple Bracelets',
    price: 22222,
    popular: false
  },
  beautiful_bracelet: {
    id: 'beautiful_bracelet',
    category: 'bracelet',
    seller: 'Stephine',
    img: 'bracelet/beautiful-bracelet_720x480.jpg',
    title: 'Beautiful Bracelet',
    price: 4500,
    popular: false
  },
  silver_band: {
    id: 'silver_band',
    category: 'bracelet',
    seller: 'Stephine',
    img: 'bracelet/silver-band_720x480.jpg',
    title: 'Sterling Silver Band with Diamonds',
    price: 36000,
    popular: true
  },
  streamlined_earing: {
    id: 'streamlined_earing',
    category: 'earing',
    seller: 'Stephine',
    img: 'earing/streamlined-earing_720x480.jpg',
    title: 'Streamlined earings',
    price: 7200,
    popular: true
  },
  acrylic_earing: {
    id: 'acrylic_earing',
    category: 'earing',
    seller: 'Stephine',
    img: 'earing/acrylic-earing_720x480.jpg',
    title: 'Acrylic Earings',
    price: 1800,
    popular: false
  },
  modern_earing: {
    id: 'modern_earing',
    category: 'earing',
    seller: 'Stephine',
    img: 'earing/modern-earing_720x480.jpg',
    title: 'Modern Earings',
    price: 2680,
    popular: true
  },
  tassel_earing: {
    id: 'tassel_earing',
    category: 'earing',
    seller: 'Stephine',
    img: 'earing/tassel-earing_720x480.jpg',
    title: 'Tassel Earings',
    price: 6880,
    popular: false
  },
  victorian_earing: {
    id: 'victorian_earing',
    category: 'earing',
    seller: 'Stephine',
    img: 'earing/victorian-earing_720x480.jpg',
    title: 'Victorian earings',
    price: 3660,
    popular: false
  },
  crystal_pendent: {
    id: 'crystal_pendent',
    category: 'necklace',
    seller: 'Stephine',
    img: 'necklace/crystal-pendent_720x480.jpg',
    title: 'Crytal Pendent',
    price: 990,
    popular: false
  },
  elegant_pendent: {
    id: 'elegant_pendent',
    category: 'necklace',
    seller: 'Stephine',
    img: 'necklace/elegant-pendent_720x480.jpg',
    title: 'Elegant Pendent',
    price: 11000,
    popular: false
  },
  handmade_necklace: {
    id: 'handmade_necklace',
    category: 'necklace',
    seller: 'Stephine',
    img: 'necklace/handmade-necklace_720x480.jpg',
    title: 'Handmade Pendent',
    price: 1800,
    popular: false
  },
  heart_shaped_pendent: {
    id: 'heart_shaped_pendent',
    category: 'necklace',
    seller: 'Stephine',
    img: 'necklace/heart-shaped-pendent_720x480.jpg',
    title: 'Heart Shaped Pendent',
    price: 5200,
    popular: true
  },
  pigeon_pendent: {
    id: 'pigeon_pendent',
    category: 'necklace',
    seller: 'Stephine',
    img: 'necklace/pigeon-pendent_720x480.jpg',
    title: 'Pigeon Pendent',
    price: 1680,
    popular: false
  },
  couple_rings: {
    id: 'couple_rings',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/couple-rings_720x480.jpg',
    title: 'Couple Rings',
    price: 3200,
    popular: false
  },
  dolphin_ring: {
    id: 'dolphin_ring',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/dolphin-ring_720x480.jpg',
    title: 'Dolphin Ring',
    price: 1300,
    popular: true
  },
  golden_ring: {
    id: 'golden_ring',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/golden-ring_720x480.jpg',
    title: 'Golden Ring',
    price: 6600,
    popular: false
  },
  ring_band: {
    id: 'ring_band',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/ring-band_720x480.jpg',
    title: 'Ring Band',
    price: 5200,
    popular: false
  },
  sea_turtle_ring: {
    id: 'sea_turtle_ring',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/sea-turtle-ring_720x480.jpg',
    title: 'Sea Turtle Ring',
    price: 2800,
    popular: true
  },
  stack_ring: {
    id: 'stack_ring',
    category: 'ring',
    seller: 'Stephine',
    img: 'ring/stack-ring_720x480.jpg',
    title: 'Stack Ring',
    price: 880,
    popular: false
  }
};
